import * as AbWorkflow from '../util/workflow'

export const saveDataRecord = (view, dataSource, data, isNew = true) => {
  return AbWorkflow.callMethod(
    'AbCommonResources-DataSourceService-loadDataSourceFromFile',
    [view, dataSource]
  ).then(result => {
    if (result.code === 'executed') {
      dataSource = Ab.data.createDataSourceForFields(result.data)
      let record = new Ab.data.Record()
      record.isNew = isNew
      Object.keys(data).forEach(key => record.setValue(key, data[key]))
      // TODO: Make dataSource.saveRecord async
      let newRecord = dataSource.saveRecord(record)
      return Promise.resolve(newRecord)
    } else {
      return Promise.reject(result.detailedMessage)
    }
  })
}

export const updateDataRecord = (view, dataSource, record) => {
  return AbWorkflow.callMethod(
    'AbCommonResources-DataSourceService-loadDataSourceFromFile',
    [view, dataSource]
  ).then(result => {
    if (result.code === 'executed') {
      dataSource = Ab.data.createDataSourceForFields(result.data)
      dataSource.saveRecord(record)
    } else {
      return Promise.reject(result.detailedMessage)
    }
  })
}
